exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-6d362eec] {\n    font-style: italic;\n}\n", ""]);

// exports
